module.exports = __webpack_public_path__ + "static/mobile-shells-217cfa9231cab3bf43991d643c3497a9.svg";